module.exports = __webpack_public_path__ + "img/index_pic28.952cb104.png";